module.exports = __webpack_public_path__ + "img/G+G.5d6a5d27.jpg";